/* tokens.js — ported VERBATIM from code.txt (lines 31-32, 355-357, 359-374). Do not edit formulas:
   plan.md §12 pins them with golden tests. */

import { STOP, NAV_WORDS } from "./constants.js";

export const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
export const titleCase = s => s.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1));

export const toks = q => q.toLowerCase().replace(/[^a-z0-9 ]/g, " ").split(/\s+/).filter(w => w && !STOP.has(w));
export const sig = q => { const t = [...new Set(toks(q))].sort((a, b) => b.length - a.length).slice(0, 2).sort(); return t.join(" "); };

export const hostTokens = site => String(site || "").split(".").map(x => x.toLowerCase()).filter(x => x.length >= 3 && !["www", "com", "net", "org"].includes(x));

/* The BRAND is the registrable label — the label just left of the domain's public
   suffix — never the suffix itself and never a subdomain. hostTokens cannot supply it:
   its exclusion list only knows www/com/net/org and short labels, so botpresso.store
   would have yielded "store" as the brand. Walk from the right instead: drop the final
   label (the TLD, whatever it is), drop a secondary suffix like co.uk / com.au / org.in,
   and take what remains. sell.amazon.in → "amazon"; treating "sell" as a brand word made
   isBrandQuery swallow the site's own content searches ("how to sell on amazon"): on that
   site it discarded 67% of all impressions before the analysis ever ran. */
const SECOND_LEVEL_SUFFIX = new Set(["co", "com", "net", "org", "gov", "edu", "ac", "mil"]);
export const brandTokens = site => {
  const labels = String(site || "").toLowerCase().split(".").filter(Boolean);
  if (labels.length > 1) labels.pop();
  if (labels.length > 1 && SECOND_LEVEL_SUFFIX.has(labels[labels.length - 1])) labels.pop();
  const brand = labels[labels.length - 1];
  return brand && brand.length >= 3 && brand !== "www" ? [brand] : [];
};
export const oneEdit = (a, b) => {
  if (Math.abs(a.length - b.length) > 1) return false;
  let i = 0, j = 0, edits = 0;
  while (i < a.length && j < b.length) {
    if (a[i] === b[j]) { i++; j++; continue; }
    if (++edits > 1) return false;
    if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
  }
  return edits + (a.length - i) + (b.length - j) <= 1;
};
export const isBrandQuery = (q, hToks) => {
  const ts = toks(q); if (!ts.length) return true;
  return ts.every(t => NAV_WORDS.has(t) || /^\d/.test(t) || hToks.some(h =>
    (t.length >= 3 && h.startsWith(t)) || (h.length >= 3 && t.startsWith(h)) || (t.length >= 5 && oneEdit(t, h))));
};
